import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { signInWithAeronet } from "../lib/auth";
import { AuthScreen, AuthSpinner, AuthButton } from "../components/AuthScreen";

export function LoginPage() {
  const location = useLocation();
  const authError = (location.state as { authError?: string } | null)?.authError;
  const redirectedRef = useRef(false);
  const [error, setError] = useState(authError ?? "");

  const redirectToCognito = () => {
    setError("");
    try {
      signInWithAeronet();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Hosted sign-in is not configured.");
    }
  };

  useEffect(() => {
    if (authError || redirectedRef.current) return;
    redirectedRef.current = true;
    redirectToCognito();
  }, [authError]);

  return (
    <AuthScreen>
      {error ? (
        <>
          <div style={{ fontSize: 16, fontWeight: 500, color: "#e7ebee" }}>Couldn’t reach Aeronet sign-in</div>
          <div style={{ fontSize: 13.5, lineHeight: 1.6, color: "#aeb6bd" }}>{error}</div>
          <AuthButton onClick={redirectToCognito}>Try again</AuthButton>
        </>
      ) : (
        <>
          <AuthSpinner />
          <div style={{ fontSize: 15, fontWeight: 500, color: "#e7ebee" }}>Taking you to Aeronet sign-in…</div>
          <div style={{ fontSize: 13, color: "#8a9299" }}>You’ll come right back here once you’re signed in.</div>
        </>
      )}
    </AuthScreen>
  );
}
